import React from 'react';

import Breadcrumbs from '@/components/Breadcrumb/components/Breadcrumbs';

import { inlineBreadcrumbs } from './styles';

const HeaderBreadcrumbs = () => <Breadcrumbs className={inlineBreadcrumbs} />;

export default React.memo(HeaderBreadcrumbs);
